import { render, staticRenderFns } from "./EventoHospedagem.vue?vue&type=template&id=24637a48&scoped=true"
import script from "./EventoHospedagem.vue?vue&type=script&lang=js"
export * from "./EventoHospedagem.vue?vue&type=script&lang=js"
import style0 from "./EventoHospedagem.vue?vue&type=style&index=0&id=24637a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24637a48",
  null
  
)

export default component.exports